import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import TransactionServices from "../TransactionServices";
import Pagination from "components/Common/newPagination";
import InvoiceImportLog from "./InvoiceImportLog";
import { CommonUtilities } from "commonUtils";

export default function ItemCodeSearch(param: any) {

    let [search_isrc, setSearch_isrc] = useState("");
    let [flags_isrc, setFlags_isrc] = useState(false);
    let [errorStatus, setErrorStatus] = useState(false);
    let [select_asset, setSelectAsset] = useState<any>([]);
    let [search_release, setSearch_release] = useState("");
    let [Flags_release, setFlags_release] = useState(false);
    let [search_contract, setSearch_contract] = useState("");
    let [Flags_contract, setFlags_contract] = useState(false);
    let [search_isrc_list, setSearch_isrc_list] = useState<any>([]);
    let [search_release_list, setSearch_release_list] = useState<any>([]);
    let [search_contract_list, setSearch_contract_list] = useState<any>([]);

    const searchRelease = () => {

        if (search_release.length < 3) {
            CommonUtilities.showToastDawer('Enter at least a 3 characters query', 'fail')
        } else {
            TransactionServices.getItemCodeSoldCompilations({ catLogNum: search_release }).then((respond: any) => {
                search_release_list = respond?.compilation ?? {};
                setSearch_release_list(search_release_list)
            })
        }
    }

    const searchISRC = () => {

        if (search_isrc.length < 3) {
            CommonUtilities.showToastDawer('Enter at least a 3 characters query', 'fail')
        } else {
            TransactionServices.getItemCodeSoldTracks({ intStdRecCde: search_isrc }).then((respond: any) => {
                search_isrc_list = respond?.track ?? {};
                setSearch_isrc_list(search_isrc_list)
                console.log(search_isrc_list)
            })
        }
    }

    const searchContract = () => {

        if (search_release.length < 3) {
            CommonUtilities.showToastDawer('Enter at least a 3 characters query', 'fail')
        } else {

            TransactionServices.getItemCodeSoldContracts({ conRefNum: search_contract }).then((respond: any) => {
                search_contract_list = respond?.contract ?? {};
                setSearch_contract_list(search_contract_list)
            })
        }
    }

    const select_itemCode = (assetType: any, dataSelect: any) => {
        console.log(assetType)
        console.log(dataSelect)
        var payload = {
            assetType: assetType,
            data: dataSelect
        }
        select_asset = payload
        setSelectAsset(select_asset)

        console.log(payload)
        //param.ItemCodeClose(payload)
    }

    const highLight = (assetType: any, dataSelect: any) => {

        var found_sts = false;

        if (select_asset?.assetType == assetType) {

            if (dataSelect?.intStdRecCode && select_asset?.data?.intStdRecCode == dataSelect?.intStdRecCode) {
                found_sts = true;
            }

            if (dataSelect?.catLogNumber && select_asset?.data?.catLogNumber == dataSelect?.catLogNumber) {
                found_sts = true;
            }

            if (dataSelect?.contractRefNum && select_asset?.data?.contractRefNum == dataSelect?.contractRefNum) {
                found_sts = true;
            }
        }

        return found_sts;
    }

    const ItemCodeClose = () => { param.ItemCodeClose(); }


    const selectAsset = () => {

        if (!select_asset?.data) {
            CommonUtilities.showToastDawer('You need to select either an ISRC, a Release or a Contract', 'fail')
        } else {
            param.ItemCodeClose(select_asset);
        }
    }

    return (
        <>

            <Modal open={param.ItemCodeOpen} onClose={ItemCodeClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-10 paddingCenterBox bgTransparent' }} >
                <div className="ws-12 box allowHscroll allowVscroll landing">

                    <div className="box-header-main well">  <h2>Select an item code</h2>  </div>

                    <div className="box-content">
                        {errorStatus && <div className="alert alert-danger">You need to select either an <i>ISRC</i>, a <i >Release</i> or a <i >Contract</i></div>}

                        <div className="ws-12">
                            <div className="w-32 mr box borderRounded ps">

                                <div className="form-format">
                                    <label className="control-label text-bold">ISRC</label>

                                    <div className="ws-9">
                                        <input type="text" placeholder="Enter an ISRC to search" className="ws-12" id="ISRC" value={search_isrc} onChange={(e: any) => setSearch_isrc(e.target.value)} />
                                    </div>

                                    <div className="ws-2">
                                        <a className="icon-btn edit" title="Search" onClick={searchISRC}>  <i className="icon-search"></i>  </a>
                                    </div>
                                </div>

                                {search_isrc_list?.length == 0 && <div className="alert alert-info mt" data-ng-hide="tracks.length > 0">No tracks to display, search for tracks</div>}
                                {flags_isrc && <div className="alert alert-danger mtc">Enter at least a 3 characters query</div>}
                                <div className="ws-12 allowHscroll allowVscroll height320">
                                    {
                                        search_isrc_list?.map((values: any) => {
                                            return (
                                                <div className={highLight("intStdRecCode", values) ? "ws-12 ps paleblue" : "ws-12 ps"} onClick={() => select_itemCode("intStdRecCode", values)}>
                                                    <span className="ws-12 forceSingleLine">{values?.intStdRecCode} ({values?.trackTitle} - {values?.isrcArtistName})</span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                            </div>

                            <div className="w-31 mr box borderRounded ps">
                                <div className="form-format">
                                    <label className="control-label">ReleaseFormats</label>
                                    <div className="ws-9">
                                        <input type="text" placeholder="Enter a release to search" className="ws-12" id="release" value={search_release} onChange={(e: any) => setSearch_release(e.target.value)} />
                                    </div>
                                    <div className="ws-2">
                                        <a className="icon-btn edit" title="Search" onClick={searchRelease}>  <i className="icon-search"></i> </a>
                                    </div>
                                </div>
                                {search_release_list?.length == 0 && <div className="alert alert-info mt">No releases to display, search for releases</div>}
                                {Flags_release && <div className="alert alert-danger mt">Enter at least a 3 characters query</div>}

                                <div className="ws-12 allowHscroll allowVscroll height320">
                                    {
                                        search_release_list?.map((values: any) => {
                                            return (
                                                <div className={highLight("catLogNumber", values) ? "ws-12 ps paleblue" : "ws-12 ps"} onClick={() => select_itemCode("catLogNumber", values)}>
                                                    <span className="ws-12 forceSingleLine">{values?.catLogNumber} ({values?.releaseTitle} - {values?.artistName})</span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                            <div className="w-32 box borderRounded ps">
                                <div className="form-format">
                                    <label className="control-label">Contract</label>

                                    <div className="ws-9">
                                        <input type="text" placeholder="Enter a contract to search" className="ws-12" id="contract" value={search_contract} onChange={(e: any) => setSearch_contract(e.target.value)} />
                                    </div>
                                    <div className="ws-2">
                                        <a className="icon-btn edit" title="Search" onClick={searchContract}>  <i className="icon-search"></i>   </a>
                                    </div>
                                </div>
                                {search_contract_list?.length == 0 && <div className="alert alert-info mt" data-ng-hide="contracts.length > 0">No contracts to display, search for contracts</div>}
                                {Flags_contract && <div className="alert alert-danger mt ">Enter at least a 3 characters query</div>}


                                <div className="ws-12 allowHscroll allowVscroll height320">
                                    {
                                        search_contract_list?.map((values: any) => {
                                            return (
                                                <div className={highLight("contractRefNum", values) ? "ws-12 ps paleblue" : "ws-12 ps"} onClick={() => select_itemCode("contractRefNum", values)}>
                                                    <span className="ws-12 forceSingleLine">{values?.contractRefNum} ({values?.contractTitle})</span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="box-footer pull-right">
                        <button className="icon-btn edit btn-sm" onClick={selectAsset}>  <i className="icon-tick"></i> Select Code</button>
                        <button className="icon-btn delete btn-sm" onClick={ItemCodeClose}>  <i className="icon-close"></i> Close</button>
                    </div>

                </div>
            </Modal>
        </>
    )

}